const userLogin = "rememberUser";
const localStorageMap = new Map();
const sessionStorageMap = new Map();
const initStorageMap = function (){
    localStorageMap.set("userLogin","rememberUser")
    localStorageMap.set("localMainMsg","localMainMsg-")
    sessionStorageMap.set("authorization","authorization")
    sessionStorageMap.set("lastPath","lastPath")
    sessionStorageMap.set("currentUserCount","localUserCount")
    sessionStorageMap.set("pukeRoomId","roomId")
}

let storageUtil = {
    initStorageMap(){
        initStorageMap()
    },
    getLocalMap(){
        return localStorageMap
    },
    getSessionMap(){
        return sessionStorageMap
    },
    getUserLogin(){
        return localStorage.getItem(localStorageMap.get("userLogin"))
    },
    setUserLogin(data){
        localStorage.setItem("userLogin",data)
    },
    getLocalMainMsg(){
        return JSON.parse(localStorage.getItem(localStorageMap.get("localMainMsg")+this.getCurrentUserCount()))
    },
    setLocalMainMsg(data){
        localStorage.setItem(localStorageMap.get("localMainMsg")+this.getCurrentUserCount(),data)
    },
    removeLocalMainMsg(userCount){
        console.log(userCount)
        localStorage.removeItem(localStorageMap.get("localMainMsg")+userCount)
    },
    getAuthorization(){
        return sessionStorage.getItem(sessionStorageMap.get("authorization"))
    },
    setAuthorization(data){
        sessionStorage.setItem("authorization",data)
    },
    getLastPath(){
        return sessionStorage.getItem(sessionStorageMap.get("lastPath"))
    },
    setLastPath(data){
        sessionStorage.setItem("lastPath",data)
    },
    getCurrentUserCount(){
        return sessionStorage.getItem(sessionStorageMap.get("currentUserCount"))
    },
    setCurrentUserCount(data){
        sessionStorage.setItem(sessionStorageMap.get("currentUserCount"),data)
    },
    getPukeRoomId(){
        return sessionStorage.getItem(sessionStorageMap.get("pukeRoomId"))
    },
    setPukeRoomId(data){
        sessionStorage.setItem("pukeRoomId",data)
    },




}

export default storageUtil
